import MarketplaceTeam from "marketplace/teams/team";

export default class MarketplaceTeamAPIRequest {
  public readonly isVisible?: boolean;
  public readonly name: string;
  public readonly description?: string;
  public readonly categories?: string[];
  
  public get payload(): this {
    return this;
  }

  public constructor(team: MarketplaceTeam) {
    this.isVisible = team.isVisible;
    this.name = team.profile.name;
    this.description = team.profile.description;
    this.categories = team.profile.categories ?? [];
  }
}
